module.exports = __webpack_public_path__ + "img/badge-highest-lead-quality-silver.5840b020.png";